import { render, staticRenderFns } from "./AccountTickets.vue?vue&type=template&id=fde3eb5a&"
import script from "./AccountTickets.vue?vue&type=script&lang=js&"
export * from "./AccountTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports